export const SCHEDULE_TIME_FORMAT = {
  hour: 'numeric', // '2-digit' for leading zero
  minute: '2-digit',
  hourCycle: 'h12',
} as const;
